"use strict";

const style = require('!!css-loader?{"sourceMap":false}!postcss-loader!./style/index.css').default;

module.exports =`
    <style>${style}</style>
    <div class="swiftref-tooltip"></div>
`;
